import axios from 'axios';
import { API_ENDPOINTS } from '../config/apiConfig';
import { endExpiredSession } from '../utils/sessionExpiry';

interface StudentResponse {
  success: boolean;
  message: string;
  data: Array<{
    _id: string;
    userId: string;
    fullName: string;
    subjects: string[];
    rollNumber: string;
    salesChannelId: string;
    profileImageurl: string;
    grade: string;
    section: string;
    schoolId: string;
    phoneNumber: string;
    joinType: string;
    securityPin: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    schoolName: string;
  }>;
}

export const studentsService = {
  getStudents: async (userId: string, token: string): Promise<StudentResponse> => {
    try {
      const response = await axios.get(
        `${API_ENDPOINTS.schoolApi}/students?userId=${userId}`,
        {
          headers: {
            'accept': 'application/json, text/plain, */*',
            'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
            'authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error: any) {
      // Handled here as well as in the global interceptor: this is the first call the
      // app makes after sign in, so an expired token surfaces here before anywhere else.
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        endExpiredSession();
      }
      throw error;
    }
  },
};